export default function Footer() {
  return (
    <footer className="w-full z-0  h-[100px] backdrop-blur-md shadow-lg  flex items-center mt-5 justify-center">
      <h2 className="text-md text-gray-600 select-none mt-auto mb-1">Copyright © 2025 JEVIS | All Rights Reserved</h2>
    </footer>
  );
}
